<template>
  <el-dialog :close-on-click-modal="false" custom-class="webpay" :visible.sync="visibleInner" top="1vh">
    <company-form />
    <span slot="title">
      <h1>Заявка на подключение</h1>
    </span>
    <span slot="footer" class="modal-footer-description">
      <p class="text-red-sm">* - поля, обязательные для заполнения</p>
      <p class="text-info">
        Отправка заявки не влечет автоматического заключения договора. Обращаем
        внимание, что банк-эквайер вправе отказать в заключении договора в
        одностороннем порядке без объяснения причин в соответствии с внутренней
        политикой банка.
      </p>

      <div class="aligner">
        <el-button round plain type="primary" @click="visibleInner = false"
          >Отправить заявку</el-button
        >
      </div>
    </span>
  </el-dialog>
</template>

<script>
import CompanyForm from './CompanyForm.vue'

export default {
  components: { 'company-form': CompanyForm },
  name: 'company-modal',
  props: ['visible'],
  computed: {
    visibleInner: {
      get () {
        return this.visible
      },
      set (val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  }
}
</script>

<style>
.modal-footer-description .text-red-sm {
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #fe9292;
}

.modal-footer-description .text-info {
  font-size: 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.3;
  letter-spacing: normal;
  text-align: center;
  color: #c1c1c1;
}
</style>
